import axios from "axios";
import type { DigitalAsset } from "../types";

const API_BASE_URL = process.env.REACT_APP_API_BASEURL + "/DigitalAssets";

export const getDigitalAssetById = async (
  id: number,
): Promise<DigitalAsset | null> => {
  const response = await axios.get<DigitalAsset>(`${API_BASE_URL}/ById/${id}`);
  return response.data ?? null;
};
